import {Component, OnInit} from '@angular/core';
import {Caisse} from './caisse';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    const caisses = [
      '01 * * CPAM',
      '02 * * MSA',
      '03 * * RSI',
      '04 * * SNCF',
      '05 * * RATP',
      '06 * * ENIM',
      '07 * * CNMSS',
      '90 * * CAVIMAC',
      '93 * * MGP',
      '95 * * MNH',
      '999390603 CAMIEG',
      '961969600 HFP',
      '99609 * INTERIALE',
      '92 * * LMG',
      '94194 * SOLSANTIS',
      '07225 * CANSSM',
      '<code> Autre',
    ];

    caisses.forEach(v => {
      const metadata = v.split(' ');
      const id = metadata[0];
      const name = metadata[metadata.length - 1];
      Caisse.caisses.set(id, new Caisse(id, name, v));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts